module.exports = __webpack_public_path__ + "img/1-md.afae29f7.jpg";